// ============================================================================
// executive-nav — section « CE » de la nav (GC-B, source unique du gate)
// ============================================================================
// La section CE de la sidebar (M-670 / P-CE14) est visible ADMIN Systeme C SEUL
// (director/manager/employee refuses cote SERVEUR — c'est LA difference vs la
// section « Comite de gestion », visible `management`). C'est une AFFORDANCE de nav
// (M-402) : l'autorite reste serveur, la sidebar ne DECIDE rien. Le gate est ICI
// (source unique, testee) — App.tsx (sidebar desktop + MoreMenuSheet mobile) et le
// test de gate nav le consomment.
//
// Anti liens morts (lecon POC-DEAD-LINK) : UNIQUEMENT les ecrans qui EXISTENT —
// « Grille salariale » (ce chantier GC-B) + « Equite salariale » (placeholder L05
// deja route). « Resultat financier detaille » (item 11) attend E2b : pas de lien
// mort tant que l'ecran n'existe pas.

import type { LucideIcon } from 'lucide-react';
import { Table2, Scale, Settings } from 'lucide-react';
import type { SystemCRole } from '../../hooks/useMe';

export interface ExecutiveNavItem {
  key: string;
  /** Cle i18n du libelle (resolue par App.tsx / le test). */
  labelKey: string;
  icon: LucideIcon;
  path: string;
}

/** Items de la section CE (ordre fidele PoC : grille puis equite, puis Admin AD-A). */
export const EXECUTIVE_NAV_ITEMS: readonly ExecutiveNavItem[] = [
  { key: 'grilleCe', labelKey: 'gest:nav.grilleCe', icon: Table2, path: '/grille-salariale' },
  { key: 'equite', labelKey: 'gest:nav.equite', icon: Scale, path: '/equite-salariale' },
  // AD-A : l'entree « Administration » vit dans CETTE section (MASTER AD-A :
  // item admin-only aligne sur le gate existant, on n'invente pas un 2e gate) —
  // meme regle serveur (P-ADM-2 admin SEUL, miroir M-670).
  { key: 'admin', labelKey: 'gest:nav.administration', icon: Settings, path: '/admin' },
] as const;

/** Gate de la section CE : ADMIN Systeme C UNIQUEMENT (jamais GESTIONNAIRE/UTILISATEUR). */
export function canSeeExecutiveNav(role: SystemCRole | null | undefined): boolean {
  return role === 'ADMIN';
}

/** Items de la section CE selon le role (tableau VIDE = section non rendue). */
export function executiveNavItemsFor(role: SystemCRole | null | undefined): readonly ExecutiveNavItem[] {
  return canSeeExecutiveNav(role) ? EXECUTIVE_NAV_ITEMS : [];
}
